import {
  TCsvQuoteStyleTranslations,
} from './select-csv-quote-style.ts';

const translations: TCsvQuoteStyleTranslations = {
  necessary: {
    title: 'Iba keď je to nevyhnutné',
    description: 'Táto možnosť vkladá polia do úvodzoviek iba vtedy, keď je to potrebné. Sú vyžadované, ak polia obsahujú úvodzovky, oddeľovač alebo zakončenie záznamu. Úvodzovky sú tiež vyžadované pri zapisovaní prázdneho záznamu. Toto je predvolené nastavenie.',
  },
  always: {
    title: 'Vždy',
    description: 'Všetky polia sú vždy uzavreté v úvodzovkách.',
  },
  non_numeric: {
    title: 'Nenumerické',
    description: 'Úvodzovky sa vkladajú okolo všetkých polí, ktoré nie sú číslami. Pri zapisovaní poľa, ktoré nie je platným číslom s pohyblivou rádovou čiarkou alebo celým číslom, sa použijú úvodzovky, aj keď nie sú nevyhnutné',
  },
  never: {
    title: 'Nikdy',
    description: 'Polia nie sú nikdy uzavreté v úvodzovkách, aj keď to môže spôsobiť neplatné dáta CSV',
  },
};

export default {
  placeholder: '',
  label: 'Štýl úvodzoviek',
  options: translations,
};
